import dayjs from "dayjs";
import calendar from "dayjs/plugin/calendar.js";
dayjs.extend(calendar);
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["de"] = "de";
  return Language2;
})(Language || {});
const setLocale = async (lang) => {
  await import("dayjs/locale/de.js");
  dayjs.locale(lang);
};
export {
  Language as L,
  setLocale as s
};
//# sourceMappingURL=i18nDate.js.map
